var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WsButtonWithPopup001',{attrs:{"width-stretch":"","text-label":"匯出","leading-icon":"icon-cloud-download","btn-list":_vm.list},on:{"btn-click":function($event){return _vm.$emit('createSubmit', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }